import TrialSearchViewModel from './TrialSearchViewModel';

function TrialResultViewModel({ defaultCondition, defaultLocation, widgetId } = {}) {
  const self = this;
  self.trialSearch = new TrialSearchViewModel({
    defaultCondition,
    defaultLocation,
    widgetId,
  });
}

export default TrialResultViewModel;
